import { useBreak } from "hooks/useBreak";
import { Label } from "./Overview.label";
import { MobileLabel } from "./MobileOverview.label";

import { _bootstrap } from "state/store.bootstrap";
import { getFocus, useAtom, useGet } from "state/jotai";
import { current_language, rotate_by_slider } from "state/store.global";

import { AnimatePresence, motion } from "framer-motion";

export const Overview = ({
  index,
  rmode,
  status,
  showLabel,
  setShowLabel,
  hoveredId,
}) => {
  const labelOptions = getFocus(_bootstrap, "projectnames");

  const currentLanguage = useAtom(current_language)[0];
  const isRotateDone = useGet(rotate_by_slider);
  const isDesktop = useBreak("md_up");

  // ✅ KEEP (main positions)
  const L = [
    { L1: [140, 197], L2: [290, 197] , L3: [450, 197] , L4: [630, 197] , L5: [800, 197],  L6: [960, 197]},
    
  ];

  // ✅ Mobile positions (kept separate)
  const mobileL = [
    { L1: [144, 192], L2: [304, 192], L3: [480, 192], L4: [630, 192], L5: [800, 192], L6: [960, 192] },
   
  ];

  const animation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.1, ease: "linear" },
  };

  if (!(status === "DONE" && isRotateDone)) return null;

  return (
    <AnimatePresence>
      {labelOptions?.[currentLanguage]?.map((label, i) => {
        if (!i) return null;

        const position = isDesktop
          ? L?.[index]?.[`L${i}`]
          : mobileL?.[index]?.[`L${i}`];

        if (!position) return null;

        return (
          <motion.div {...animation} key={i}>
            {isDesktop ? (
              <Label
                c={position}
                d={40}
                rmode={rmode}
                labelsInfo={label}
                showLabel={showLabel}
                hoveredId={hoveredId}
              />
            ) : (
              <MobileLabel
                c={position}
                d={40}
                rmode={rmode}
                labelsInfo={label}
                showLabel={showLabel}
                setShowLabel={setShowLabel}
                hoveredId={hoveredId}
              />
            )}
          </motion.div>
        );
      })}
    </AnimatePresence>
  );
};